<template>
  <FusionReleaseNotesHistory />
</template>
